import { Box, Tab, Tabs } from "@mui/material";
import { Add, BarChart, PlayArrow } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import NotebookIcon from "@/fragments/NotebookIcon";

export default function ConsoleTabs() {
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();

  const searchParams = useSearchParams()[0];
  const view = searchParams.get("view", "usage");

  const handleTabChange = (e, newValue) => {
    switch (newValue) {
      case 0:
        navigate(`/console?view=usage`);
        break;
      case 1:
        navigate(`/console?view=songs`);
        break;
      case 2:
        navigate(`/console?view=new-artist`);
        break;
    }
  };

  useEffect(() => {
    if (view === "usage") {
      setTab(0);
    } else if (view === "songs") {
      setTab(1);
    } else if (view === "new-artist") {
      setTab(2);
    }
  }, [view]);

  return (
    <>
      {/* Mobile bottom tabs */}
      <Box sx={{ display: { xs: "block", lg: "none" } }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="secondary"
          variant="fullWidth"
          slotProps={{
            indicator: {
              sx: { top: 0 },
            },
          }}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            bgcolor: "rgba(36, 36, 36, 0.95)",
            pt: 0,
            pb: 0,
            "& .MuiTab-root": {
              minWidth: "70px",
              height: "80px",
            },
          }}
        >
          <Tab icon={<BarChart />} label="Usage" iconPosition="start" />
          <Tab
            icon={
              <Box sx={{ display: "flex", alignItems: "center", pr: 0.3 }}>
                <NotebookIcon size={24} />
              </Box>
            }
            label="Songs"
            iconPosition="start"
          />
          <Tab
            icon={
              <Box sx={{ display: "flex", alignItems: "center", pr: 0.3 }}>
                <Add size={24} />
              </Box>
            }
            label="Artist"
            iconPosition="start"
          />
        </Tabs>
      </Box>

      {/* Desktop side tabs */}
      <Box sx={{ display: { xs: "none", lg: "block" } }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          orientation="vertical"
          variant="fullWidth"
          slotProps={{
            indicator: {
              sx: { left: 0 },
            },
          }}
          sx={{
            position: "fixed",
            left: 20,
            top: "25%",
            transform: "translateY(-50%)",
            bgcolor: "rgba(18, 18, 18, 0.95)",
            width: "140px",
            "& .MuiTab-root": {
              minHeight: "70px",
              width: "100%",
              padding: "10px",
              justifyContent: "flex-start",
              gap: 1,
            },
          }}
        >
          <Tab icon={<BarChart />} label="Usage" iconPosition="start" />
          <Tab
            icon={
              <Box sx={{ display: "flex", alignItems: "center", pr: 0.3 }}>
                <NotebookIcon size={20} />
              </Box>
            }
            label="Songs"
            iconPosition="start"
          />
          <Tab
            icon={
              <Box sx={{ display: "flex", alignItems: "center", pr: 0.3 }}>
                <Add size={24} />
              </Box>
            }
            label="Artist"
            iconPosition="start"
          />
        </Tabs>
      </Box>
    </>
  );
}
